import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import axios from "axios";
import { base_url } from "../../context/Authcontext";
import { AuthContext } from "../../context/Authcontext";
import React, { useEffect, useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ChevronDown } from "lucide-react";
// import '../../assets/AdminCss/games.css';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faImage, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "../../context/ThemeContext";
import MarqueeBottom from "../components/MarqueeBottom";
import ToastMessage from "../ToastMessage";

const SportsBets = () => {
  const { themeColors } = useTheme();
  const [isSidebar, setSidebar] = useState(false);
  const [data, setData] = useState([]);
  const [statement, setStatement] = useState([]);
  const base_url = process.env.REACT_APP_API_URL;
  const location = useLocation();

  const [active, setActive] = useState(location.state?.activeTab || 0);
  const [showCanvas, setShowCanvas] = useState(false);

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);
  const [settlementtData, setSettlementData] = useState([]);
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setActive(location.state.activeTab);
    }
  }, [location.state?.activeTab]); // Watch for changes in state

  useEffect(() => {
    const sportData = async () => {
      try {
        const response = await axios.get(base_url + "/api/webapi/sportData", {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log("bet Response data:", response.data);
        setData(response?.data);
      } catch (error) {
        console.error("Error fetching sport data:", error);
      }
    };

    const accountStatement = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/webapi/accountStatement",
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("Response baba:", response.data);
        setSettlementData(response.data.accountSettlement);
        // Store the entire response data to access all arrays
        setStatement(response.data);
      } catch (error) {
        console.error("Error fetching account statement:", error);
      }
    };

    const history = async () => {
      const gameToken = localStorage.getItem("game_token");
      if (!gameToken) {
        console.warn("Missing game_token, skipping history call.");
        return;
      }

      try {
        const response = await axios.get(
          base_url + "/api/webapi/casinoHistory",
          {
            params: {
              gameToken,
            },
            withCredentials: true,
            headers: {
              "content-type": "application/json",
            },
          }
        );
      } catch (err) {
        console.log(err);
      }

      // console.log('history',response);
    };

    history();
    accountStatement();
    sportData();
  }, []);

  useEffect(() => {
    if (active === 0 || active === 1 || active === 2 || active === 3 || active === 4 || active === 5 || active === 6 || active === 7) {
      setShowCanvas(false);
    }
  }, [active]);

  return (
    <>
      <Sidebar isSidebar={isSidebar} setSidebar={setSidebar} />
      <div style={{ background: "var(--dark-theme-color-navbar)" }}>
        <Header
          isSidebar={isSidebar}
          setSidebar={setSidebar}
          show={showCanvas}
          handleShow={handleCanvasShow}
          handleClose={handleCanvasClose}
        />
        <div
          _ngcontent-tgc-c107=""
          className="content "
          style={{ height: "100vh", marginBottom: "8rem",
            // width: isSidebar ? "84%" : "100%",
           }}
        >
          <reports-top-nav _nghost-tgc-c127="">
            <ul
              _ngcontent-tgc-c127=""
              className="popular-tab custom-scrollbar m-0 pb-2 mt-lg-0 "
            >
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 3 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(3)}
              >
                {" "}
                Account Statement{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 0 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(0)}
              >
                {" "}
                Sports Bets{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 1 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(1)}
              >
                {" "}
                Casino Bets{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 2 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(2)}
              >
                {" "}
                Fancy Bets{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 4 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(4)}
              >
                {" "}
                Profit & Loss{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 5 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(5)}
              >
                {" "}
                Change Password{" "}
              </li>
              <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 6 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(6)}
              >
                {" "}
                Result{" "}
              </li>
              {/* <li
                _ngcontent-tgc-c127=""
                routerlinkactive="active"
                className={`fs-16 sm-fs-14 ng-star-inserted cursor-pointer ${
                  active === 7 ? "active" : ""
                }`}
                tabIndex="0"
                onClick={() => setActive(7)}
              >
                {" "}
                AccountSettlement{" "}
              </li> */}
            </ul>
          </reports-top-nav>
          {active === 0 && <SportsBetsHistory data={data} />}
          {active === 1 && <CasinoBetsHistory />}
          {active === 2 && <FancyBetsHistory />}

          {active === 3 && <Accountstatement data={statement} />}
          {active === 4 && <ProfitLoss data={data} />}
          {active === 5 && <ChangePassword />}
          {active === 6 && <Result />}
          {active === 7 && <AccountSettlement data={settlementtData} />}
        </div>
        <MarqueeBottom onMenuClick={handleCanvasShow} />
      </div>
    </>
  );
};

// Bet times are stored as local IST text, e.g. "2026-10-22 03:15:20 PM".
// Parse that explicitly: `new Date(text)` is invalid in Safari and for empty
// values, and `.toISOString()` on an invalid date throws, which blanked the
// whole history. Returns "YYYY-MM-DD" in the same local calendar, or "".
const betDay = (time) => {
  const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(time || "").trim());
  if (!m) return "";
  return `${m[1]}-${m[2].padStart(2, "0")}-${m[3].padStart(2, "0")}`;
};

// "YYYY-MM-DD" for today +/- n days, in the viewer's local calendar (not UTC,
// which is a day behind in India until 05:30).
const localDay = (offsetDays = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + offsetDays);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Default window. It used to be yesterday..tomorrow, so any bet older than
// a day was hidden and players saw "No data available".
const DEFAULT_HISTORY_DAYS = 30;

const SportsBetsHistory = ({ data }) => {
  const [startDate, setStartDate] = React.useState(() => localDay(-DEFAULT_HISTORY_DAYS));

  const [endDate, setEndDate] = React.useState(() => localDay(1));

  const [filteredData, setFilteredData] = React.useState([]);
  const [originalData, setOriginalData] = React.useState([]); // ✅ store original merged data

  // Initialize with the original data
  React.useEffect(() => {
    const sportData = data?.sportData || [];
    const racingData = data?.racingData || [];

    const mergedData = [...sportData, ...racingData];
    // Newest first. Sort on id where present (insertion order): the time text
    // does not sort reliably and cannot always be parsed.
    mergedData.sort((a, b) => (Number(b.id) || 0) - (Number(a.id) || 0));

    setOriginalData(mergedData); // ✅ keep original
    setFilteredData(mergedData);
  }, [data]);

  // Handle form submission
  const handleLoadReport = React.useCallback(
    (e) => {
      e?.preventDefault();

      const filtered = originalData.filter((item) => {
        const itemDateOnly = betDay(item.time);
        // A row whose time cannot be read is shown rather than dropped.
        if (!itemDateOnly) return true;
        return (
          (!startDate || itemDateOnly >= startDate) &&
          (!endDate || itemDateOnly <= endDate)
        );
      });

      setFilteredData(filtered);
    },
    [originalData, startDate, endDate]
  );

  // ✅ Reset filter
  const handleReset = () => {
    // Changing the dates re-runs handleLoadReport through its effect.
    setStartDate(localDay(-DEFAULT_HISTORY_DAYS));
    setEndDate(localDay(1));
  };

  React.useEffect(() => {
    handleLoadReport();
  }, [handleLoadReport]);

  return (
    <>
      <div className="mt-3">
        <form
          onSubmit={handleLoadReport}
          className="form-container"
          style={{
            display: "flex",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Start Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Start Date:
            </p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              End Date:
            </p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-demoaccount)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>

          {/* ✅ Reset Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="button"
              onClick={handleReset}
              style={{
                width: "100%",
                backgroundColor: "#ccc",
                color: "#000000",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>

 <div className="table-responsive">
       {/* Table */}
      <table className="pb-5 w-100">
    <thead>
      <tr className="p-2 bb">
        <th className="text-start text-nowrap bb bg-black text-white">
          Tournament Name
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Market Name
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Runner Name
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Side
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Odds
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Price
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Status
        </th>
        <th className="text-center text-nowrap bb bg-black text-white">
          Placed Date
        </th>
      </tr>
    </thead>
        <tbody>
          {filteredData && filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <tr
                key={index}
                className="border"
                style={{
                  background:
                    item.side === "Lay"
                      ? "linear-gradient(180deg, #f59dc2, #f5e9ee)"
                      : "linear-gradient(180deg, #84c2f1, #d9efff)",
                }}
              >
                <td className="text-start p-2 text-black bb">
                  {item.competitionName}
                </td>
                <td className="text-center text-black bb">{item.eventName}</td>
                <td className="text-center text-black bb">{item.runnerName}</td>
                <td className="text-center text-black bb">{item.side}</td>
                <td className="text-center text-black bb">{item.betprice}</td>
                <td className="text-center text-black bb">{item.betAmount}</td>
                {/* <td className="text-center text-black bb">
                  {item.status === 1 && item.side === "Lay"
                    ? item.profit
                    : item.status === 2
                    ? item.betAmount
                    : item.status === 10
                    ? item.cashoutAmount
                    : "-"}
                </td> */}

                {/* <td className="text-center text-black bb">
                  {item.status === 1 && item.side === "Lay"
                    ? item.betAmount
                    : item.status === 2 && item.side === "Lay"
                    ? item.deducted_amount
                    : item.status === 1 && item.side === "Back"
                    ? item.deducted_amount
                    : item.status === 2 && item.side === "Back"
                    ? item.betAmount
                    : "-"}
                </td> */}

                <td className="text-center text-black bb">
                  <span
                    className={`${item.status === 4 && "text-danger"}`}
                    style={{
                      backgroundColor:
                        item.status === 1 || item.status === 10
                          ? "rgb(3, 187, 22)" // Win or Cashout - Green
                          : item.status === 2
                          ? "rgba(255, 0, 0, 1)" // Loss - Red
                          : item.status === 3
                          ? "rgba(108, 117, 125, 1)" // Void / Tie (refund) - Grey
                          : item.status === 4
                          ? ""
                          : "rgba(255, 193, 7, 1)", // Pending - Yellow
                      fontWeight: "700",
                      padding: "3px 8px",
                      borderRadius: "4px",
                      color: "white",
                      display: "inline-block",
                      minWidth: "70px",
                    }}
                  >
                    {item.status === 1
                      ? "Win"
                      : item.status === 2
                      ? "Loss"
                      : item.status === 3
                      ? "Void"
                      : item.status === 10
                      ? "Cashout"
                      : item.status === 4
                      ? item.remark || "Bet Cancelled"
                      : "Pending"}
                  </span>
                </td>

                <td className="text-center text-black bb">
                  {new Date(item.time).toLocaleString()}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
 </div>
    </>
  );
};

const CasinoBetsHistory = () => {
  const [fullHistory, setFullHistory] = useState([]); // original full data
  const [filteredHistory, setFilteredHistory] = useState([]); // filtered view
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/webapi/myCasinoHistory",
          {
            withCredentials: true,
            headers: { "content-type": "application/json" },
          }
        );

        const data = response?.data?.histry || [];
        setFullHistory(data);
        setFilteredHistory(data); // Initially show all
      } catch (err) {
        console.error(err);
      }
    };

    fetchHistory();
  }, []);

  const handleLoadReport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      setFilteredHistory(fullHistory); // No filtering if dates are empty
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999); // include entire end day

    const filtered = fullHistory.filter((item) => {
      const [datePart] = item.time.split(","); // Extract "28/7/2025"
      const [day, month, year] = datePart.split("/").map(Number);

      const itemDate = new Date(year, month - 1, day); // JS months are 0-based

      return itemDate >= start && itemDate <= end;
    });

    setFilteredHistory(filtered);
  };

  // ✅ Reset handler
  const handleReset = () => {
    setStartDate("");
    setEndDate("");
    setFilteredHistory(fullHistory); // restore original full data
  };

  return (
    <>
      <div className="mt-3 ">
        <form
          className="form-container"
          onSubmit={handleLoadReport}
          style={{
            display: "flex",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Start Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Start Date
            </p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              End Date
            </p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-demoaccount)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>

          {/* ✅ Reset Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="button"
              onClick={handleReset}
              style={{
                width: "100%",
                backgroundColor: "#ccc",
                color: "#000",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      {/* Table */}
      <table className="pb-5 w-100 table-responsive-sm">
        <thead
          style={{ backgroundColor: "var(--dark-theme-dark-blue-variant1)" }}
        >
          <tr className="p-2  bb">
            <th className=" text-center text-nowrap text-white bb">
              Game Code
            </th>
            <th className=" text-center text-nowrap text-white bb">
              Game Category
            </th>
            <th className=" text-center text-nowrap text-white bb">Round ID</th>
            <th className=" text-center text-nowrap text-white bb">Bet Amount</th>
            <th className=" text-center text-nowrap text-white bb">Status</th>
            <th className=" text-center text-nowrap text-white bb">Bet time</th>
            <th className=" text-center text-nowrap text-white bb">
              Result Time
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredHistory.length > 0 ? (
            filteredHistory.map((hist, index) => (
              <tr key={index} className="border">
                <td className="bb">{hist?.gameId}</td>
                <td className="bb">{hist?.gameCategory}</td>
                <td className="text-center bb">{hist?.playerGameRoundId}</td>
                <td className="text-center bb">{hist?.amount}</td>
                <td className="text-center bb">
                  <span
                    className="rounded px-2"
                    style={{
                      background:
                        hist?.status === "lose"
                          ? "rgba(227, 7, 7, 1)"
                          : "rgb(3,187,22)",
                    }}
                  >
                    {hist?.status === "win" ? "Win" : "Lose"}
                  </span>
                </td>
                <td className="text-center bb">{hist?.time}</td>
                <td className="text-center bb">{hist?.result_time}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-white">
                No Data found for your game.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const FancyBetsHistory = () => {
  const [fancyDataHistory, setfancyDataHistory] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    const sportData = async () => {
      // console.log("Devansh is devansh ")
      try {
        const response = await axios.get(
          base_url + "/api/webapi/getFancyDataHistory",
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        // console.log("Response data: of fancy", response.data.history);
        setfancyDataHistory(response?.data?.history);
      } catch (error) {
        console.error("Error fetching sport data:", error);
      }
    };

    sportData();
  }, []);

  const handleLoadReport = (e) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      setfancyDataHistory(fancyDataHistory); // No filtering if dates are empty
      return;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999); // include entire end day

    const filtered = fancyDataHistory.filter((item) => {
      const itemDate = new Date(item.time);
      return itemDate >= start && itemDate <= end;
    });

    setfancyDataHistory(filtered);
  };

  return (
    <>
      <div className="mt-3 ">
        <form
          className="form-container"
          onSubmit={handleLoadReport}
          style={{
            display: "flex",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
        >
          {/* Start Date & Time */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Start Date
            </p>

            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  placeholder="dd-mm-yyyy"
                  style={{
                    width: "100%",
                    backgroundColor: "var(--dark-theme-dark-blue-variant)",
                    color: "white",
                    border: "none",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
              </div>

              <div style={{ position: "relative", flex: 1 }}>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  defaultValue="10:48:21"
                  style={{
                    width: "100%",
                    backgroundColor: "var(--dark-theme-dark-blue-variant)",
                    color: "white",
                    border: "none",
                    padding: "10px",
                    borderRadius: "4px",
                    paddingRight: "30px",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-demoaccount)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>
        </form>
      </div>
      <table
        className="pb-5 table-responsive-sm table-responsive-md w-100 "
        style={{ backgroundColor: "var(--dark-theme-dark-blue-variant1)" }}
      >
        <thead
          style={{
            backgroundColor: "var(--dark-theme-dark-blue-variant1)",
            color: "white",
          }}
        >
          <tr className="p-2  bb">
            <th
              className="text-center text-nowrap  bb "
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Market ID
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Market Name
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Runner Name
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Side
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Price
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Rate
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              {" "}
              Size
            </th>
            {/* <th className="text-center text-nowrap bb">Profit/Loss</th>
            <th className="text-center text-nowrap bb">Status</th> */}

            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Placed Date
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {fancyDataHistory.map((item, index) => (
            <tr
              key={index}
              className="border flex-wrap"
              style={{
                backgroundColor:
                  item?.side === "yes"
                    ? "var(--dark-theme-data-box)"
                    : "#faa9ba",
                color: "black",
                height: "40px",
              }}
            >
              <td className="text-center text-nowrap bb ml-2">
                {item.marketId}
              </td>
              <td className="text-center text-nowrap bb">
                <span>{item.competitionName}</span>
                <span> / </span>
                <span>{item.eventName}</span>
                <span> / </span>
                <span>{item.runnerName}</span>
                <span>
                  {" "}
                  / <strong>Result:</strong>{" "}
                </span>
                <span>{item.result ? item.result : "Pending"}</span>
              </td>

              <td className="text-center text-nowrap bb">{item.runnerName}</td>
              <td className="text-center text-nowrap bb">{item.side}</td>
              <td className="text-center text-nowrap bb">{item.betprice}</td>
              <td className="text-center text-nowrap bb">{item.rate}</td>
              <td className="text-center text-nowrap bb">{item.betAmount}</td>
              <td className="text-center text-nowrap bb">
                {new Date(item.time).toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const AccountSettlement = ({ data }) => {
  const [settlementtData, setSettlementData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [sportDataObj, setSportDataObj] = useState({
    sportData: [],
    amount: 0,
  });
  const [fullHistory, setFullHistory] = useState([]); // original full data
  const [filteredHistory, setFilteredHistory] = useState([]); // filtered view

  // applied states (used only after Load Report)
  const [appliedStartDate, setAppliedStartDate] = React.useState("");
  const [appliedEndDate, setAppliedEndDate] = React.useState("");
  const [appliedFilterType, setAppliedFilterType] = React.useState("all");

  const getSetlementData = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/accountStatement",
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
          },
          params: { startDate, endDate },
        }
      );
      // console.log("Response baba:", response.data);
      setSettlementData(response.data.accountSettlement);
    } catch (error) {
      console.error("Error fetching account statement:", error);
    }
  };

  function getReportByDate() {
    if(!startDate || !endDate){
      toast.error("Please select start date and end date");
      return;
    }

    if(startDate > endDate){
      toast.error("Start date should be less than end date");
      return;
    }

    getSetlementData()
  }

  const getSetlementDataInPdf = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/accountStatementPdf",
        {
          withCredentials: true,
          responseType: "blob", // 👈 important
          params: { startDate, endDate },
        }
      );

      // Create a blob link to download
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      // Auto download
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", "account-settlement.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();

      // OR: just open in new tab
      // window.open(fileURL);
    } catch (error) {
      console.error("Error fetching account statement:", error);
    }
  };

  const getSettlementDataInExcel = async () => {
  try {
    const response = await axios.get(
      base_url + "/api/webapi/accountStatementExcel",
      {
        withCredentials: true,
        responseType: "blob", // important for binary files
        params: { startDate, endDate },
      }
    );

    // Determine file type and name
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const fileURL = URL.createObjectURL(blob);

    // Auto download
    const link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", "account-settlement.xlsx"); // .xlsx for Excel
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Optional: open in new tab
    // window.open(fileURL);
  } catch (error) {
    console.error("Error fetching account statement:", error);
  }
  };

  // ✅ Reset handler
  const handleReset = () => {
    setFilterType("all");
    setStartDate("");
    setEndDate("");
    setAppliedFilterType("all");
    setAppliedStartDate("");
    setAppliedEndDate("");
  };

  // console.log("SEttlement data is form the code  ", data);

  // ---- fetch sports data ----
  const sportData1 = async () => {
    try {
      const response = await axios.get(base_url + "/api/webapi/sportData", {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      setSportDataObj(response?.data || { sportData: [], amount: 0 });
    } catch (error) {
      console.error("Error fetching sport data:", error);
    }
  };
  useEffect(() => {
    sportData1();
    getSetlementData();
  }, []);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(
          base_url + "/api/webapi/myCasinoHistory",
          {
            withCredentials: true,
            headers: { "content-type": "application/json" },
          }
        );

        const data = response?.data?.histry || [];
        setFullHistory(data);
        setFilteredHistory(data); // Initially show all
        // console.log(data, "jfjef");
      } catch (err) {
        console.error(err);
      }
    };

    fetchHistory();
  }, []);

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  // ---- date helpers ----
  function toDateSafe(any) {
    if (!any && any !== 0) return null;
    // epoch ms or numeric
    if (/^\d{13,}$/.test(String(any))) return new Date(Number(any));
    // "YYYY-MM-DD HH:mm:ss AM/PM" | "YYYY-MM-DD HH:mm:ss"
    const m = String(any).match(
      /(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*(AM|PM))?/i
    );
    if (m) {
      let [, Y, M, D, h, mi, s, ap] = m;
      let hour = parseInt(h, 10);
      if (ap) {
        ap = ap.toUpperCase();
        if (ap === "PM" && hour < 12) hour += 12;
        if (ap === "AM" && hour === 12) hour = 0;
      }
      return new Date(
        Number(Y),
        Number(M) - 1,
        Number(D),
        hour,
        Number(mi),
        s ? Number(s) : 0
      );
    }
    // fallback
    const d = new Date(any);
    return isNaN(d) ? null : d;
  }

  // helper to normalize "YYYY-DD-MM h:mm:ss AM/PM" -> "YYYY-MM-DD HH:mm:ss AM/PM"
  function normalizeTodayFormat(dateStr) {
    if (!dateStr) return dateStr;

    const m = String(dateStr).match(
      /(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2}):(\d{2})\s*(AM|PM)?/i
    );

    if (m) {
      let [, Y, part1, part2, h, mi, s, ap] = m;

      // Decide if backend sent YYYY-DD-MM (invalid) or YYYY-MM-DD (valid)
      let year = parseInt(Y, 10);
      let first = parseInt(part1, 10); // could be DD or MM
      let second = parseInt(part2, 10); // could be MM or DD

      let month, day;

      if (first > 12 && second <= 12) {
        // Format is YYYY-DD-MM → needs swap
        month = second;
        day = first;
      } else {
        // Already YYYY-MM-DD
        month = first;
        day = second;
      }

      // Pad values
      month = String(month).padStart(2, "0");
      day = String(day).padStart(2, "0");
      let hour = String(h).padStart(2, "0");
      let sec = String(s).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${mi}:${sec} ${
        ap?.toUpperCase() || ""
      }`.trim();
    }

    return dateStr;
  }

  function parseDateOnly(dateStr) {
    if (!dateStr) return null;
    const d = toDateSafe(dateStr);
    if (!d) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  function formatDateTime(ts) {
    const d = toDateSafe(ts);
    return d ? d.toLocaleString() : "N/A";
  }

  const parsedStartDate = parseDateOnly(startDate);
  const parsedEndDate = parseDateOnly(endDate);

  if (!data) return <div>Loading transaction data...</div>;

  const accountData = data.accountStmt || [];
  const withdrawalData = data.accwithdraw || [];
  const depositData = data.account || [];
  const cashout = data.cashout || [];

  // ---------- STEP 1: Build base ledger ----------
  // Filter deposits to only include status === 1 (approved/successful)
  const approvedDeposits = depositData.filter((item) => item.status === 1);

  const baseEvents = [
    // Chips (if used in your app)
    ...accountData.map((item, idx) => ({
      key: `chips-${idx}`,
      t: toDateSafe(item.time || item.today)?.getTime() || 0,
      time: item.time || item.today,
      today: item.today,
      type: item.type, // "credit" | "debit"
      amount: Number(item.amount) || 0,
      balance: item.main_balance,
      RunningBalance: item.main_balance,
      transactionType: "Chips",
      providerName: item.providerName || "",
      status: item.status,
      remarks: item.remark,
      dataSource: "accountStmt",
    })),

    // Deposit - Only approved deposits (status === 1)
    ...approvedDeposits.map((item, idx) => {
      const timeStr = normalizeTodayFormat(item.today);
      const money = parseFloat(item.money) || 0;

      return {
        key: `dep-${idx}`,
        t: toDateSafe(timeStr)?.getTime() || 0,
        time: timeStr,
        today: timeStr,
        type: "credit",
        amount: money,
        balance: null, // Will be calculated in the ledger processing
        RunningBalance: null, // Will be calculated in the ledger processing
        transactionType: "Deposit",
        providerName: item.type || "",
        status: item.status,
        remarks: item.remarks || "Deposit",
        dataSource: "account",
      };
    }),

    // Withdrawal
    ...withdrawalData
      .filter((item) => String(item.status) === "1")
      .map((item, idx) => {
        const timeStr = normalizeTodayFormat(item.today);
        const money = parseFloat(item.money) || 0;

        return {
          key: `wd-${idx}`,
          t: toDateSafe(timeStr)?.getTime() || 0,
          time: timeStr,
          today: timeStr,
          type: "debit",
          amount: money,
          balance: null, // Will be calculated in the ledger processing
          RunningBalance: null, // Will be calculated in the ledger processing
          transactionType: "Withdrawal",
          providerName: item.name_bank || "",
          status: item.status,
          remarks: item.remarks || "Withdrawal",
          dataSource: "accwithdraw",
        };
      }),

    // Cashout
    ...cashout.map((item, idx) => ({
      key: `cashout-${idx}`,
      t: toDateSafe(item.time)?.getTime() || 0,
      time: item.time,
      today: item.time,
      type: item.cashoutAmount >= 0 ? "credit" : "debit",
      amount: Math.abs(Number(item.cashoutAmount) || 0),
      balance: null, // Will be calculated in the ledger processing
      RunningBalance: null, // Will be calculated in the ledger processing
      transactionType: "cashout",
      providerName: `${item.sportname}/${item.eventName}/of bet ${item.betAmount}`,
      status: item.status,
      remarks: item.remarks,
      dataSource: "cashout",
    })),
  ].sort((a, b) => a.t - b.t);

  // ---------- STEP 2: Calculate running balances properly ----------
  let runningBalance = 0; // Start with 0 or get from initial balance if available

  // Process base events and calculate running balances
  baseEvents.forEach((event) => {
    event.balance = runningBalance.toFixed(2); // Balance before transaction

    if (event.type === "credit") {
      runningBalance += event.amount;
    } else if (event.type === "debit") {
      runningBalance -= event.amount;
    }

    event.RunningBalance = runningBalance.toFixed(2); // Balance after transaction
  });

  // Create the main ledger
  const ledger = [...baseEvents];

  // Helper functions for inserting sports and casino data
  function getPrevAfterBalance(t) {
    let prev = null;
    for (let i = ledger.length - 1; i >= 0; i--) {
      if (ledger[i].t <= t) {
        prev = ledger[i];
        break;
      }
    }
    if (!prev) return runningBalance; // Use current running balance if no previous entry
    const rb = parseFloat(prev.RunningBalance);
    return isNaN(rb) ? 0 : rb;
  }

  function insertIntoLedger(entry) {
    let i = ledger.findIndex((e) => e.t > entry.t);
    if (i === -1) {
      ledger.push(entry);
    } else {
      ledger.splice(i, 0, entry);
    }

    // Recalculate running balances from the insertion point
    let startIndex = i === -1 ? ledger.length - 1 : i;
    for (let j = startIndex; j < ledger.length; j++) {
      if (j === 0) {
        ledger[j].balance = "0.00";
        runningBalance = 0;
      } else {
        ledger[j].balance = ledger[j - 1].RunningBalance;
        runningBalance = parseFloat(ledger[j - 1].RunningBalance);
      }

      if (ledger[j].type === "credit") {
        runningBalance += ledger[j].amount;
      } else if (ledger[j].type === "debit") {
        runningBalance -= ledger[j].amount;
      }

      ledger[j].RunningBalance = runningBalance.toFixed(2);
    }
  }

  // Add Casino data
  const casinoSorted = (fullHistory || []).slice().sort((a, b) => {
    const ta = toDateSafe(normalizeTodayFormat(a.time))?.getTime() || 0;
    const tb = toDateSafe(normalizeTodayFormat(b.time))?.getTime() || 0;
    return ta - tb;
  });

  casinoSorted.forEach((item, idx) => {
    const timeStr = normalizeTodayFormat(item.time);
    const t = toDateSafe(timeStr)?.getTime() || 0;
    const before = getPrevAfterBalance(t);

    const isWin =
      String(item.status).toLowerCase() === "win" || item.type === "PAYOUT";
    const amt = isWin
      ? parseFloat(item.profit) || 0
      : parseFloat(item.amount) || parseFloat(item.profit) || 0;

    const after = isWin ? before + amt : before - amt; // Win adds money, loss subtracts

    insertIntoLedger({
      key: `casino-${idx}`,
      t,
      time: timeStr,
      today: timeStr,
      type: isWin ? "credit" : "debit",
      amount: amt,
      balance: before.toFixed(2),
      RunningBalance: after.toFixed(2),
      transactionType: "Casino",
      providerName: `${item.gameProvider} | ${item.gameCategory} | ${item.gameId}`,
      status: item.status,
      remarks: item.roundStatus,
      dataSource: "casino",
    });
  });

  // Add Sports data
  const sportsSorted = (sportDataObj.sportData || []).slice().sort((a, b) => {
    const ta = toDateSafe(a.time)?.getTime() || 0;
    const tb = toDateSafe(b.time)?.getTime() || 0;
    return ta - tb;
  });

  sportsSorted.forEach((item, idx) => {
    const tPlaced = toDateSafe(item.time)?.getTime() || 0;
    const baseBeforePlaced = getPrevAfterBalance(tPlaced);

    const betAmount = parseFloat(item.betAmount) || 0;

    // PLACED (always record)
    const placed = {
      key: `sport-place-${idx}`,
      t: tPlaced,
      time: item.time,
      today: item.time,
      type: "debit",
      amount: betAmount,
      balance: baseBeforePlaced.toFixed(2),
      RunningBalance: (baseBeforePlaced - betAmount).toFixed(2),
      transactionType: "Sports Bet (Placed)",
      providerName: `${item.sportname} | ${item.eventName} | ${item.runnerName}`,
      status: 0,
      remarks: item.remark || "",
      dataSource: "sportdata",
    };
    insertIntoLedger(placed);

    // RESULT (if any)
    if (item.status === 1 || item.status === 2 || item.status === 3) {
      const tResult =
        toDateSafe(item.resultdate || item.time)?.getTime() || tPlaced;
      const beforeResult = getPrevAfterBalance(tResult);

      if (item.status === 1) {
        const profit = parseFloat(item.profit) || 0;
        const won = {
          key: `sport-win-${idx}`,
          t: tResult,
          time: item.resultdate || item.time,
          today: item.resultdate || item.time,
          type: "credit",
          amount: betAmount + profit,
          balance: beforeResult.toFixed(2),
          RunningBalance: (beforeResult + profit).toFixed(2),
          transactionType: "Sports Bet (Won)",
          providerName: `${item.sportname} | ${item.eventName} | ${item.runnerName}`,
          status: 1,
          remarks: item.remark || "",
          dataSource: "sportdata",
        };
        insertIntoLedger(won);
      } else if (item.status === 2) {
        const lost = {
          key: `sport-lost-${idx}`,
          t: tResult,
          time: item.resultdate || item.time,
          today: item.resultdate || item.time,
          type: "credit",
          amount: 0,
          balance: beforeResult.toFixed(2),
          RunningBalance: beforeResult.toFixed(2),
          transactionType: "Sports Bet (Lost)",
          providerName: `${item.sportname} | ${item.eventName} | ${item.runnerName}`,
          status: 2,
          remarks: item.remark || "Lost",
          dataSource: "sportdata",
        };
        insertIntoLedger(lost);
      } else if (item.status === 3) {
        // Tie / Void: the stake (liability) is refunded. updateResult stores
        // the refunded amount in profit, so credit it back here.
        const refund = parseFloat(item.profit) || 0;
        const voided = {
          key: `sport-void-${idx}`,
          t: tResult,
          time: item.resultdate || item.time,
          today: item.resultdate || item.time,
          type: "credit",
          amount: refund,
          balance: beforeResult.toFixed(2),
          RunningBalance: (beforeResult + refund).toFixed(2),
          transactionType: "Sports Bet (Void)",
          providerName: `${item.sportname} | ${item.eventName} | ${item.runnerName}`,
          status: 3,
          remarks: item.remark || "Void / Refund",
          dataSource: "sportdata",
        };
        insertIntoLedger(voided);
      }
    }
  });

  // ---------- STEP 3: Apply filters & sorting for display ----------
  const inRange = (item) => {
    if (!(parsedStartDate || parsedEndDate)) return true;
    const d = toDateSafe(item.time);
    if (!d) return false;
    const day = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    if (parsedStartDate && day < parsedStartDate) return false;
    if (parsedEndDate && day > parsedEndDate) return false;
    return true;
  };

  const typeMatches = (item) => {
    if (filterType === "all") return true;
    const mapping = {
      deposit: "Deposit",
      withdraw: "Withdrawal",
      chips: "Chips",
      cashout: "cashout",
      sports: "Sports Bet",
    };
    const match = mapping[filterType];
    if (!match) return true;
    return (
      item.transactionType === match || item.transactionType?.startsWith(match)
    );
  };

  const filtered = ledger.filter((e) => typeMatches(e) && inRange(e));
  const sortedDesc = filtered.sort((a, b) => b.t - a.t);

  // Show closing balance as the after-balance of the most recent row
  // const closingBalance = sortedDesc.length > 0
  //   ? sortedDesc[0].RunningBalance
  //   : (sportDataObj?.amount ?? 0);

  const credit = data?.reduce((sum, item) => {
    return sum + Number(item.credit || 0);
  }, 0);

  console.log(credit);

  const debit = data?.reduce((sum, item) => {
    return sum + Number(item.debit || 0);
  }, 0);

  console.log("betbit", debit);

  const closingBalance = (credit - debit).toFixed(2);

  console.log("closing beelance ", closingBalance);

  return (
    <>
      {/* Filter Form */}
      <div className="mt-3">
        <form
          className="form-container"
          style={{
            display: "flex",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
          onSubmit={(e) => {
            e.preventDefault();
            setAppliedFilterType(filterType);
            setAppliedStartDate(startDate);
            setAppliedEndDate(endDate);
          }}
        >
          {/* Filter Type */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Filter Type
            </p>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            >
              <option value="all">All</option>
              {/* <option value="deposit">Deposit</option>
              <option value="withdraw">Withdraw</option> */}
              {/* <option value="chips">Chips</option>
              <option value="cashout">Cashout</option> */}
            </select>
          </div>

          {/* Start Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Start Date
            </p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              End Date
            </p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* Load Report Button */}
          <div style={{ display: "flex", gap: "10px", marginTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-demoaccount)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                getReportByDate();
              }}
            >
              Report
            </button>

            <button
              style={{
                width: "100%",
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                getSetlementDataInPdf();
              }}
            >
              PDF
            </button>

            <button
              style={{
                width: "100%",
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onClick={() => {
                getSettlementDataInExcel();
              }}
            >
              Excel
            </button>
          </div>

          {/* ✅ Reset Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="button"
              onClick={handleReset}
              style={{
                width: "100%",
                backgroundColor: "gray",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      {/* Closing Balance */}
      <div className="text-right font-bold p-2 bg-light">
        Closing Balance: {closingBalance}
      </div>

      <table
        className="pb-5 table-responsive-sm table-responsive-md pl-1"
        style={{ width: "99%" }}
      >
        <thead>
          <tr className="p-3">
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="20%"
            >
              Date
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="15%"
            >
              Credit
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="15%"
            >
              Debit
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="15%"
            >
              Balance
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="35%"
            >
              Description
            </th>
          </tr>
        </thead>
        <tbody>
          {/* Opening Balance Row */}
          <tr className="bg-gray-100 font-semibold">
            <td className="text-center text-nowrap p-2 bb">--</td>
            <td className="text-center text-nowrap bb">-</td>
            <td className="text-center text-nowrap bb">-</td>
            <td className="text-center text-nowrap bb">{closingBalance}</td>
            <td className="text-center text-nowrap p-2 bb">Closing Balance</td>
          </tr>

          {settlementtData?.length > 0 ? (
            settlementtData.map((ele) => (
              <tr key={ele.key} className="border">
                <td className="text-center text-nowrap p-2 bb">{ele.date}</td>
                <td
                  className="text-center text-nowrap bb"
                  style={{ color: "green" }}
                >
                  {Number(ele.credit) === 0 ? "-" : ele.credit}
                </td>
                <td
                  className="text-center text-nowrap bb"
                  style={{ color: "red" }}
                >
                  {Number(ele.debit) === 0 ? "-" : ele.debit}
                </td>
                <td
                  className="text-center text-nowrap bb"
                  style={{ color: "green" }}
                >
                  {ele.balance ?? "0"}
                </td>
                <td className="text-center text-nowrap p-2 bb">{ele.remark}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-light">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

const Accountstatement = ({ data }) => {
  const [selectedImage, setSelectedImage] = React.useState(null);
  const [showImageModal, setShowImageModal] = React.useState(false);

  // input states (user typing)
  const [startDate, setStartDate] = React.useState("");
  const [endDate, setEndDate] = React.useState("");
  const [filterType, setFilterType] = React.useState("all");

  // applied states (used only after Load Report)
  const [appliedStartDate, setAppliedStartDate] = React.useState("");
  const [appliedEndDate, setAppliedEndDate] = React.useState("");
  const [appliedFilterType, setAppliedFilterType] = React.useState("all");

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  function formatDateTime(timestamp) {
    if (!timestamp) return "N/A";
    try {
      if (timestamp.toString().length >= 13) {
        return new Date(parseInt(timestamp)).toLocaleString();
      }
      return new Date(timestamp).toLocaleString();
    } catch (e) {
      return timestamp.toString();
    }
  }

  function parseDate(dateStr) {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (isNaN(d)) return null;
    return new Date(d.toDateString());
  }

  if (!data) return <div>Loading transaction data...</div>;

  const accountData = data.accountStmt || [];
  const withdrawalData = data.accwithdraw || [];
  const depositData = data.account || [];
  const cashout = data.cashout || [];

  // Merge all transactions
  const combinedTransactions = [
    ...accountData.map((item) => ({
      type: item.type,
      amount: item.amount,
      balance: item.main_balance,
      time: item.time,
      today: item.today,
      status: item.status,
      remarks: item.remark,
      proof_image: item.proof_image,
      providerName: item.providerName || "",
      transactionType: "Chips",
      RunningBalance: item.main_balance,
      dataSource: "accountStmt",
    })),
    ...depositData.map((item) => ({
      type: "credit",
      amount: item.money,
      balance: item.remaining_bet,
      time: item.time,
      today: item.today,
      status: item.status,
      remarks: item.remarks,
      providerName: item.type || "",
      transactionType: "Deposit",
      RunningBalance: item.RunningBalance,
      dataSource: "account",
    })),
    ...withdrawalData.map((item) => ({
      type: "debit",
      amount: item.money,
      balance: "",
      remarks: item.remarks,
      status: item.status,
      time: item.time,
      today: item.today,
      providerName: item.name_bank || "",
      transactionType: "Withdrawal",
      RunningBalance: item.RunningBalance,
      dataSource: "accwithdraw",
    })),
    ...cashout.map((item) => ({
      type: "cashout",
      amount: item.cashoutAmount,
      balance: item.balance,
      remarks: item.remarks,
      status: item.status,
      time: item.time,
      today: item.time,
      providerName: `${item.sportname}/${item.eventName}/of bet ${item.betAmount}`,
      transactionType: "cashout",
      RunningBalance: item.balance,
      dataSource: "cashout",
    })),
  ];

  function parseTransactionDate(dateStr) {
    if (!dateStr) return 0;

    let d = new Date(dateStr);
    if (!isNaN(d.getTime())) {
      return d.getTime();
    }

    const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})\s+(.*)/);
    if (match) {
      let [, year, part1, part2, rest] = match;
      if (parseInt(part1) > 12) {
        [part1, part2] = [part2, part1];
      }
      d = new Date(`${year}-${part1}-${part2} ${rest}`);
      if (!isNaN(d.getTime())) {
        return d.getTime();
      }
    }

    return 0;
  }

  function sortTransactions(transactions) {
    return transactions.sort((a, b) => {
      const dateA = parseTransactionDate(a.today || a.time);
      const dateB = parseTransactionDate(b.today || b.time);
      return dateB - dateA;
    });
  }

  const parsedStartDate = parseDate(appliedStartDate);
  const parsedEndDate = parseDate(appliedEndDate);

  const filteredTransactions = combinedTransactions.filter((item) => {
    if (appliedFilterType !== "all") {
      const filterMapping = {
        deposit: "Deposit",
        withdraw: "Withdrawal",
        chips: "Chips",
        cashout: "cashout",
      };
      if (item.transactionType !== filterMapping[appliedFilterType]) {
        return false;
      }
    }

    if (parsedStartDate || parsedEndDate) {
      let txnDateStr = item.today;
      if (!txnDateStr && item.time) {
        txnDateStr = item.time.split(" ")[0];
      }
      const txnDate = parseDate(txnDateStr);
      if (!txnDate) return false;

      if (parsedStartDate && txnDate < parsedStartDate) return false;
      if (parsedEndDate && txnDate > parsedEndDate) return false;
    }
    return true;
  });

  const sortedTransactions = sortTransactions(filteredTransactions);

  // ✅ Reset handler
  const handleReset = () => {
    setFilterType("all");
    setStartDate("");
    setEndDate("");
    setAppliedFilterType("all");
    setAppliedStartDate("");
    setAppliedEndDate("");
  };

  return (
    <>
      {/* Filter Form */}
      <div className="mt-3">
        <form
          className="form-container"
          style={{
            display: "flex",
            padding: "10px",
            gap: "10px",
            width: "100%",
          }}
          onSubmit={(e) => {
            e.preventDefault();
            setAppliedFilterType(filterType);
            setAppliedStartDate(startDate);
            setAppliedEndDate(endDate);
          }}
        >
          {/* Filter Type */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Filter Type
            </p>
            <select
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            >
              <option value="all">All</option>
              <option value="deposit">Deposit</option>
              <option value="withdraw">Withdraw</option>
              {/* <option value="chips">Chips</option>
              <option value="cashout">Cashout</option> */}
            </select>
          </div>

          {/* Start Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              Start Date
            </p>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* End Date */}
          <div style={{ flex: 3.5 }}>
            <p
              style={{ color: "black", fontSize: "14px", marginBottom: "8px" }}
            >
              End Date
            </p>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-dark-blue-variant)",
                color: "white",
                border: "none",
                padding: "10px",
                borderRadius: "4px",
              }}
            />
          </div>

          {/* Load Report Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="submit"
              style={{
                width: "100%",
                backgroundColor: "var(--dark-theme-demoaccount)",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Load Report
            </button>
          </div>

          {/* ✅ Reset Button */}
          <div style={{ flex: 2, marginTop: "28px" }}>
            <button
              type="button"
              onClick={handleReset}
              style={{
                width: "100%",
                backgroundColor: "gray",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                padding: "10px",
                fontWeight: "bold",
                cursor: "pointer",
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>

      {/* Transactions Table */}
      <table
        className="pb-5 table-responsive-sm table-responsive-md pl-1"
        style={{ width: "99%" }}
      >
        <thead>
          <tr className="p-3">
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="30%"
            >
              Narration
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="20%"
            >
              Amount
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="20%"
            >
              Status
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="20%"
            >
              Remarks
            </th>
            <th
              className="text-center text-nowrap bb bg-black text-white"
              width="30%"
            >
              Running Balance
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedTransactions.length > 0 ? (
            sortedTransactions.map((ele, index) => (
              <tr key={index} className="border">
                <td className="text-center text-nowrap p-2 bb">
                  <b>
                    <div>
                      {ele.transactionType}{" "}
                      {ele.providerName && `By ${ele.providerName}`}
                    </div>
                    <div>{ele.today || formatDateTime(ele.time)}</div>
                  </b>
                </td>
                <td className="text-center text-nowrap bb">
                  <b
                    style={{
                      color:
                        ele.status === 2
                          ? "red"
                          : ele.status === 1
                          ? "green"
                          : ele.type === "credit"
                          ? "green"
                          : "red",
                    }}
                  >
                    {ele.amount || 0}
                  </b>
                </td>
                <td className="text-center text-nowrap bb">
                  <b
                    style={{
                      color:
                        ele.status === 0
                          ? "orange"
                          : ele.status === 1
                          ? "green"
                          : ele.status === 2
                          ? "red"
                          : ele.status === 10
                          ? "green"
                          : ele.type === "credit"
                          ? "green"
                          : ele.type === "debit"
                          ? "red"
                          : ele.type === "cashout"
                          ? "green"
                          : "white",
                    }}
                  >
                    {ele.status === 0
                      ? "pending"
                      : ele.status === 1
                      ? "confirmed"
                      : ele.status === 2
                      ? "rejected"
                      : ele.status === 10
                      ? "confirmed"
                      : ele.type === "credit"
                      ? "Deposit"
                      : ele.type === "debit"
                      ? "Withdraw"
                      : ele.type === "cashout"
                      ? "Cashout Confirmed"
                      : "unknown"}
                  </b>
                </td>
                <td className="text-center text-nowrap bb">
                  <b>{ele.remarks || "NA"}</b>
                </td>
                <td className="text-center text-nowrap bb">
                  <b>{ele.RunningBalance}</b>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center text-light">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Modal for Proof Image */}
      {showImageModal && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Transaction Proof</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeImageModal}
                ></button>
              </div>
              <div className="modal-body text-center">
                {selectedImage ? (
                  <img
                    src={selectedImage}
                    alt="Transaction Proof"
                    className="img-fluid"
                    style={{ maxHeight: "70vh" }}
                    onError={(e) => {
                      e.target.src = "/api/placeholder/400/300";
                      e.target.alt = "Image not available";
                    }}
                  />
                ) : (
                  <div className="alert alert-warning">Image not available</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeImageModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const ProfitLoss = ({ data }) => {
  const [sportFilter, setSportFilter] = React.useState("all");
  const [searchTerm, setSearchTerm] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);
  const [totalProfitLoss, setTotalProfitLoss] = React.useState(0);

  const { themeColors } = useTheme();

  // 🔽 Prepare dataset from aggregated sports + casino
  const prepareData = () => {
    const sports = data?.sports || [];
    const casinoAgg = data?.casinos ? [data.casinos] : [];

    console.log(sports, "sports");
    

    // ✅ Normalize both into a common format
    const normalizedSports = sports.map((item) => ({
      eventName: item.sport,
      profitLoss: parseFloat(item.net) || 0,
      sportname: item.sport?.toLowerCase(),
    }));

    const normalizedCasino = casinoAgg.map((item) => ({
      eventName: item.sport || "casino",
      profitLoss: parseFloat(item.net) || 0,
      sportname: "casino",
    }));

    return [...normalizedSports, ...normalizedCasino];
  };

  // 🔽 Initialize
  React.useEffect(() => {
    const combined = prepareData();
    console.log(combined, "combined");
    
    setFilteredData(combined);
    processData(combined);
  }, [data]);

  // 🔽 Process totals
  const processData = (records) => {
    let total = 0;
    records.forEach((item) => {
      total += item.profitLoss;
    });
    setTotalProfitLoss(total);
  };

  // 🔽 Handle filters
  const handleLoadReport = (e) => {
    e.preventDefault();

    const combined = prepareData();

    const filtered = combined.filter((item) => {
      let passes = true;

      // Sport filter
      if (sportFilter !== "all" && item.sportname !== sportFilter) {
        passes = false;
      }

      // Search filter (on eventName)
      if (
        searchTerm.trim() !== "" &&
        !item.eventName?.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        passes = false;
      }

      return passes;
    });

    setFilteredData(filtered);
    processData(filtered);
  };

  // 🔽 Reset
  const handleReset = () => {
    const combined = prepareData();
    setSportFilter("all");
    setSearchTerm("");
    setFilteredData(combined);
    processData(combined);
  };

  return (
    <div className="mt-3 ml-1 mr-2 p-2">
      <div className="p-2">Profit and Loss Statement</div>

      {/* 🔽 Filters */}
      <form onSubmit={handleLoadReport} className="mb-3 d-flex gap-2 flex-wrap">
        <select
          value={sportFilter}
          onChange={(e) => setSportFilter(e.target.value)}
          className="form-select"
          style={{ maxWidth: "180px" }}
        >
          <option value="all">All Sports</option>
          <option value="cricket">Cricket</option>
          <option value="tennis">Tennis</option>
          <option value="football">Football</option>
          <option value="casino">Casino</option>
        </select>

        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Enter Sport name to search"
          className="form-control w-100 text-black"
        />

        <button type="submit" className="btn btn-primary px-3">
          Load Report
        </button>

        <button
          type="button"
          className="btn btn-secondary px-3"
          onClick={handleReset}
        >
          Reset
        </button>
      </form>

      {/* 📊 Table */}
      <table className="pb-5 table-responsive-sm table-responsive-md w-100">
        <thead
          style={{ backgroundColor: "var(--dark-theme-dark-blue-variant1)" }}
        >
          <tr className="p-2">
            <th
              className="text-center text-nowrap fs-7 fw-bolder bb col-6"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Market Name
            </th>
            <th
              className="text-center text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Profit/Loss
            </th>
          </tr>
        </thead>

        <tbody>
          {filteredData && filteredData.length > 0 ? (
            <>
              {filteredData.map((item, index) => (
                <tr key={index} className="border">
                  <td className="text-start text-black p-2 bb">
                    {item.eventName}
                  </td>
                  <td
                    className="text-center text-black bb"
                    style={{
                      color: item.profitLoss >= 0 ? "green" : "red",
                      fontWeight: "bold",
                    }}
                  >
                    {item.profitLoss.toFixed(2)}
                  </td>
                </tr>
              ))}
              <tr
                className="border"
                style={{ background: "var(--dark-theme-time-remaining)" }}
              >
                <td
                  style={{ color: "#fff" }}
                  className="text-start p-2 fs-7 fw-bolder bb"
                >
                  Total:
                </td>
                <td
                  className="text-center fs-7 fw-bolder bb"
                  style={{
                    color:
                      totalProfitLoss >= 0 || totalProfitLoss >= "0"
                        ? "var(--dark-theme-data-min)"
                        : "var(--dark-theme-demoaccount)",
                  }}
                >
                  {totalProfitLoss.toFixed(2)}
                </td>
              </tr>
            </>
          ) : (
            <tr>
              <td
                style={{ color: "var(--dark-theme-white-color)" }}
                className="text-start p-2 fs-7 fw-bolder bb"
              >
                Total:
              </td>
              <td
                style={{ color: "var(--dark-theme-white-color)" }}
                className="text-start fs-7 fw-bolder bb"
              >
                0.00
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const ChangePassword = () => {
  const { themeColors } = useTheme();
  const navigate = useNavigate();
  const { isAuthenticated, changepassword, logout } = useContext(AuthContext);
  const [oldPassword, setoldPassword] = useState("");
  const [newpass, setnewpass] = useState("");
  const [confirm_pass, setconfirm_pass] = useState("");
  const [isSidebar, setSidebar] = useState(false);
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

 const submitform = (e) => {
    e.preventDefault();
    let data = {
      password: oldPassword,
      newPassWord: newpass,
      RePassWord: confirm_pass,
    };
 
    if (!oldPassword) {
      ToastMessage(0, "Current Password is required!");
      return;
    }
 
    if (oldPassword.length < 6) {
      ToastMessage(0, "Current Password  must be at least 6 characters long");
      return;
    }
 
    if (!newpass) {
      ToastMessage(0, "New Password is required!");
      return;
    }
 
    if (newpass.length < 6) {
      ToastMessage(0, "New Password  must be at least 6 characters long");
      return;
    }
 
    if (!confirm_pass) {
      ToastMessage(0, "Confirm Password is required!");
      return;
    }
 
    if (confirm_pass.length < 6) {
      ToastMessage(0, "Confirm Password  must be at least 6 characters long");
      return;
    }
 
    changepassword(data, function (res) {
      console.log(res.status);
      if (res.status) {
        message(1, res.message);
        logout();
        navigate("/");
      } else {
        message(0, res.message);
      }
    });
  };

  const message = (status, text) => {
    if (status === 1) {
      toast.success(text);
    } else if (status === 0) {
      toast.error(text);
    } else if (status === 2) {
      toast.error(text);
    }
  };

  return (
    <>
      <div
        _ngcontent-hdd-c80=""
        className=""
        style={{
          height: "100vh",
          background: "var(--dark-theme-color-navbar)",
        }}
      >
        <div className="marquee"></div>
        <app-reports _nghost-hdd-c162="" className="ng-star-inserted">
          <div _ngcontent-hdd-c162="" className="pcoded-main-container">
            <div
              _ngcontent-hdd-c162=""
              className="container-fluid pl-3 accounts-box"
            >
              <div _ngcontent-hdd-c162="" className="row account-tabs">
                {/* <Layout /> */}
                <div
                  _ngcontent-oqs-c169=""
                  className="col-12 mt-2 px-1 centralized_css"
                >
                  <app-changepassword _nghost-yqq-c159="">
                    <div
                      _ngcontent-yqq-c159=""
                      className="col-md-4 p-0 mx-auto change-pass"
                      style={{
                        background: "var(--dark-theme-color-navbar)",
                        border: "6px solid var(--dark-theme-data-box)",
                        borderRadius: "15px",
                      }}
                    >
                      <h4
                        _ngcontent-yqq-c159=""
                        className="chnage-pass-text"
                        style={{ color: "var(--dark-theme-white-color)" }}
                      >
                        Change Password
                      </h4>
                      <div
                        _ngcontent-yqq-c159=""
                        className="bg-white form-box mx-auto custom-padding"
                      >
                        <form
                          onSubmit={submitform}
                          _ngcontent-yqq-c159=""
                          noValidate=""
                          className="ng-untouched ng-pristine ng-invalid"
                        >
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Current Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link
                                _ngcontent-yqq-c159=""
                                onClick={() => setShowOld(!showOld)}
                              >
                                {showOld ? (
                                  <i className="bi bi-eye"></i>
                                ) : (
                                  <i className="bi bi-eye-slash"></i>
                                )}
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span className="user_icon">
                                  <i className="bi bi-lock"></i>
                                </span>{" "}
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                formcontrolname="current_pass"
                                autoFocus=""
                                onChange={(e) => setoldPassword(e.target.value)}
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid pt-4"
                                placeholder="Current Password"
                                type={showOld ? "text" : "password"}
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="oldPassword"
                                className="floating-label"
                              >
                                Current Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">New Password</label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link
                                _ngcontent-yqq-c159=""
                                onClick={() => setShowNew(!showNew)}
                              >
                                {showNew ? (
                                  <i className="bi bi-eye"></i>
                                ) : (
                                  <i className="bi bi-eye-slash"></i>
                                )}
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span className="user_icon">
                                  <i className="bi bi-lock"></i>
                                </span>{" "}
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) => setnewpass(e.target.value)}
                                formcontrolname="new_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid pt-4"
                                placeholder="New Password"
                                type={showNew ? "text" : "password"}
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="passInput"
                                className="floating-label"
                              >
                                New Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-3">
                            {/* <label _ngcontent-yqq-c159="">
                              Confirm Password
                            </label> */}
                            <span
                              _ngcontent-yqq-c159=""
                              className="d-flex align-items-center inner-addon form-floating"
                            >
                              <Link
                                _ngcontent-yqq-c159=""
                                onClick={() => setShowConfirm(!showConfirm)}
                              >
                                {showConfirm ? (
                                  <i className="bi bi-eye"></i>
                                ) : (
                                  <i className="bi bi-eye-slash"></i>
                                )}
                              </Link>
                              <span
                                _ngcontent-yqq-c159=""
                                className="user_icon"
                              >
                                <span className="user_icon">
                                  <i className="bi bi-lock"></i>
                                </span>{" "}
                              </span>
                              <input
                                _ngcontent-yqq-c159=""
                                onChange={(e) =>
                                  setconfirm_pass(e.target.value)
                                }
                                formcontrolname="confirm_pass"
                                className="text-dark form-control ng-untouched ng-pristine ng-invalid pt-4"
                                placeholder="Confirm Password"
                                type={showConfirm ? "text" : "password"}
                              />
                              <label
                                _ngcontent-yqq-c159=""
                                htmlFor="confirmPassInput"
                                className="floating-label"
                              >
                                Confirm Password
                              </label>
                            </span>
                          </div>
                          <div _ngcontent-yqq-c159="" className="pt-4">
                            <button
                              _ngcontent-yqq-c159=""
                              type="submit"
                              className="login-btn"
                            >
                              {" "}
                              Change Password{" "}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </app-changepassword>
                </div>
              </div>
            </div>
          </div>
        </app-reports>
      </div>
    </>
  );
};

const Result = ({ data }) => {
  const { themeColors } = useTheme();
  const sportData = data && data.length > 0 ? data : [];

  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Fancy Tennis");
  const [history, setHistory] = useState([]);
  const [fancyFetchHistory, setFancyFetchHistory] = useState([]);

  const [filterText, setFilterText] = useState(""); // 🔍 filter input
  const [showCanvas, setShowCanvas] = useState(false);

  const options = ["Fancy Tennis", "Cricket", "Casino"];

  const handleCanvasShow = () => setShowCanvas(true);
  const handleCanvasClose = () => setShowCanvas(false);

  const handleSelect = (option) => {
    setSelected(option);
    setIsOpen(false);
  };

  const fethcHistory = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/betMatchHistory",
        {
          withCredentials: true,
          headers: { Accept: "application/json" },
        }
      );

      if (response?.data.success) {
        setHistory(response.data.matchHistory);
      }

      const response2 = await axios.get(
        base_url + "/api/webapi/betFancyMatchHistory",
        {
          withCredentials: true,
          headers: { Accept: "application/json" },
        }
      );

      if (response2.data.success) {
        setFancyFetchHistory(response2.data.matchHistory);
      }
    } catch (err) {
      console.log(err);
    }
  };

  

  useEffect(() => {
    window.scrollTo(0, 0);
    fethcHistory();
  }, []);

  // ✅ Apply filtering
  const filteredHistory = history.filter((ele) => {
    const match = ele.match?.[0];
    const search = filterText.toLowerCase();
    return (
      match?.competitionname?.toLowerCase().includes(search) ||
      match?.eventname?.toLowerCase().includes(search)
    );
  });

  const filteredFancyHistory = fancyFetchHistory.filter((ele) => {
    const search = filterText.toLowerCase();
    return (
      ele.competitionName?.toLowerCase().includes(search) ||
      ele.eventName?.toLowerCase().includes(search)
    );
  });

  return (
    <>
      <style>{`
        .input_box::placeholder {
          color: black !important;
        }
      `}</style>

      {/* 🔍 Filter Input + Reset */}
      <div className="d-flex align-items-center gap-2 m-1 w-100 flex-wrap">
       <input
    type="text"
    className="form-control p-2 rounded w-100 black-placeholder input_box"
    placeholder="Filter by Competition or Event Name"
    value={filterText}
    onChange={(e) => setFilterText(e.target.value)}
  />
        <button
          className="btn btn-secondary px-3"
          onClick={() => setFilterText("")}
        >
          Reset
        </button>
      </div>

      <table className="pb-5 table-responsive-sm table-responsive-md w-100 bg-black">
        <thead
          style={{ backgroundColor: "var(--dark-theme-dark-blue-variant1)" }}
        >
          <tr className="p-2 bb" style={{ height: "40px" }}>
            <th
              className="text-start text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Competition Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Event Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Market Name
            </th>
            <th
              className="text-start text-nowrap bb"
              style={{ color: "var(--dark-theme-color-navbar)" }}
            >
              Results
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredHistory.length > 0
            ? filteredHistory.map((ele, index) => {
                const match = ele.match?.[0];
                return (
                  <tr
                    key={`match-${index}`}
                    className="border"
                    style={{
                      background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                      height: "40px",
                    }}
                  >
                    <td className="text-start text-nowrap bb">
                      {match?.competitionname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.eventname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.marketname || "N/A"}
                    </td>
                    <td className="text-start text-nowrap bb">
                      {match?.result || "Pending"}
                    </td>
                  </tr>
                );
              })
            : null}

          {filteredFancyHistory.length > 0
            ? filteredFancyHistory.map((ele, index) => (
                <tr
                  key={`fancy-${index}`}
                  className="border"
                  style={{
                    background: "linear-gradient(180deg, #f59dc2, #f5e9ee)",
                    height: "40px",
                  }}
                >
                  <td className="text-start text-nowrap bb">
                    {ele.competitionName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.eventName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.runnerName || "N/A"}
                  </td>
                  <td className="text-start text-nowrap bb">
                    {ele.result || "Pending"}
                  </td>
                </tr>
              ))
            : null}

          {filteredHistory.length === 0 &&
            filteredFancyHistory.length === 0 && (
              <tr>
                <td
                  colSpan="4"
                  className="text-center"
                  style={{ color: "var(--dark-theme-color-navbar)" }}
                >
                  No data available
                </td>
              </tr>
            )}
        </tbody>
      </table>
    </>
  );
};

export default SportsBets;
